/**
 * Findings barrel. Importing this module registers all built-in rules
 * (side effect). Consumers should call `FindingsRegistry.run(ctx)`.
 *
 * P0.3 rules plug in here by adding a new rule file + one line below.
 */

import { FindingsRegistry, registerFindingRule } from './FindingsRegistry';
import { ghostVpcRule } from './rules/ghostVpcRule';
import { strandedDataRule } from './rules/strandedDataRule';
import { sgSprawlRule } from './rules/sgSprawlRule';
import { unencryptedDataStoreRule } from './rules/unencryptedDataStoreRule';
import { publicWithoutWafRule } from './rules/publicWithoutWafRule';
import { singleAzRule } from './rules/singleAzRule';
import { orphanSecurityGroupRule } from './rules/orphanSecurityGroupRule';
import { staleResourceRule } from './rules/staleResourceRule';
import { untaggedResourceRule } from './rules/untaggedResourceRule';
import { crossAccountAdminRoleRule } from './rules/crossAccountAdminRoleRule';
import { configRuleComplianceRule } from './rules/configRuleComplianceRule';

let registered = false;

export function registerBuiltInFindingRules(): void {
  if (registered) return;
  // Bubble-scoped rules (legacy trio)
  registerFindingRule(ghostVpcRule);
  registerFindingRule(strandedDataRule);
  registerFindingRule(sgSprawlRule);
  // P0.3 resource-scoped rules
  registerFindingRule(unencryptedDataStoreRule);
  registerFindingRule(publicWithoutWafRule);
  registerFindingRule(singleAzRule);
  registerFindingRule(orphanSecurityGroupRule);
  registerFindingRule(staleResourceRule);
  registerFindingRule(untaggedResourceRule);
  registerFindingRule(crossAccountAdminRoleRule);
  // Tier 1.3 — surface AWS Config rule evaluations as findings.
  registerFindingRule(configRuleComplianceRule);
  registered = true;
}

// Ensure built-ins are registered on first import of this barrel.
registerBuiltInFindingRules();

export { FindingsRegistry, registerFindingRule };
export type { FindingRule, FindingRuleContext } from './types';
